import { ModuleWithProviders, NgModule } from '@angular/core';
import { LFeatureGroupComponent } from './components/l-feature-group.component';
import { LFeatureComponent } from './components/l-feature.component';
import { LMapComponent } from './components/l-map.component';
import { LMarkersGroupComponent } from './components/l-markers-group.component';
import { PopupComponent } from './components/popup.component';
import { TilesLayerComponent } from './components/tiles-layer.component';
import { ZoomComponent } from './components/zoom.component';
import { CONFIG, Config } from './models/config';
import { LFeaturesService } from './services/';


@NgModule({
    imports: [
        PopupComponent,
        ZoomComponent,
        LMarkersGroupComponent,
        LMapComponent,
        LFeatureComponent,
        LFeatureGroupComponent,
        TilesLayerComponent,
    ],
    providers: [
        LFeaturesService,
    ],
    exports: [
        LMapComponent,
        LFeatureComponent,
        LFeatureGroupComponent,
        LMarkersGroupComponent,
        ZoomComponent,
        TilesLayerComponent,
        PopupComponent,
        LMarkersGroupComponent,
    ],
})
export class LMapModule {

    static forRoot(config: Config): ModuleWithProviders<LMapModule> {
        return {
            ngModule: LMapModule,
            providers: [{ provide: CONFIG, useValue: config }],
        };
    }
}
